import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { FestivosLista } from "@/components/FestivosEmpresaPanel";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function MisFestivos() {
  const [year, setYear] = useState(new Date().getFullYear());
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const { data: res } = await api.get("/trabajador/festivos", {
          params: { year, limit: 100 },
        });
        if (!cancelled) setData(res);
      } catch (e) {
        if (!cancelled) {
          setData(null);
          toast.error(formatApiError(e));
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [year]);

  return (
    <div className="space-y-4" data-testid="mis-festivos-page">
      <div className="flex items-center justify-between gap-3">
        <div>
          <h1 className="font-display text-2xl font-semibold text-zinc-900 dark:text-zinc-100">
            Festivos
          </h1>
          <p className="mt-1 text-sm text-zinc-500">
            Calendario de días no laborables de tu empresa
          </p>
        </div>
        <div className="flex items-center gap-1 rounded-xl border border-indigo-100 bg-white p-1 dark:border-zinc-800 dark:bg-zinc-900">
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={() => setYear((y) => y - 1)}
            aria-label="Año anterior"
          >
            <ChevronLeft className="h-4 w-4" />
          </Button>
          <span className="min-w-[3.5rem] text-center text-sm font-semibold text-zinc-800 dark:text-zinc-200">
            {year}
          </span>
          <Button
            variant="ghost"
            size="icon"
            className="h-8 w-8"
            onClick={() => setYear((y) => y + 1)}
            aria-label="Año siguiente"
          >
            <ChevronRight className="h-4 w-4" />
          </Button>
        </div>
      </div>

      {loading ? (
        <div className="rounded-2xl border border-indigo-100/90 bg-white px-5 py-12 text-center text-sm text-zinc-400 shadow-sm dark:border-zinc-800 dark:bg-zinc-900">
          Cargando festivos…
        </div>
      ) : data?.festivos?.length ? (
        <FestivosLista data={data} />
      ) : (
        <div className="rounded-2xl border border-indigo-100/90 bg-white px-5 py-12 text-center text-sm text-zinc-500 shadow-sm dark:border-zinc-800 dark:bg-zinc-900">
          No hay festivos registrados para {data?.centro || "tu centro"} en {year}.
        </div>
      )}
    </div>
  );
}
